import { render, staticRenderFns } from "./AiApproval.vue?vue&type=template&id=a3ac9b5a&"
import script from "./AiApproval.vue?vue&type=script&lang=ts&"
export * from "./AiApproval.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports